var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:53862)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.4541C24.8366 32.4541 32 25.2907 32 16.4541C32 7.61755 24.8366 0.454102 16 0.454102C7.16344 0.454102 0 7.61755 0 16.4541C0 25.2907 7.16344 32.4541 16 32.4541Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 0.454102C15.9884 0.454227 15.3044 6.8541 15.3044 6.8541H28.8008C25.8818 2.96804 21.2346 0.454102 16.0001 0.454102Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9997 32.4545C21.2342 32.4545 25.8814 29.9405 28.8004 26.0545H3.19897C6.11797 29.9405 10.7652 32.4545 15.9997 32.4545Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6797 13.2543H15.3044L16.0001 19.6543H31.6797C31.8897 18.6203 32.0001 17.5502 32.0001 16.4543C32.0001 15.3583 31.8896 14.2882 31.6797 13.2543V13.2543Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 19.6541C16 16.315 16 4.2106 16 0.454102C7.1635 0.454102 0 7.6176 0 16.4541C0 17.55 0.1105 18.6202 0.320375 19.6541H16Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.82857 8.10669L9.86457 11.2951H13.2174L10.5051 13.2659L11.5409 16.4545L8.82857 14.4839L6.11619 16.4545L7.15225 13.2659L4.43994 11.2951H7.79263L8.82857 8.10669Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:53862"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.454102)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTogo);
export default __webpack_public_path__ + "static/media/togo.d56c1c7b.svg";
export { ForwardRef as ReactComponent };